export const GET_MY_ORDER_IDS = "APP/MY_ORDER/GET_MY_ORDER_IDS";
export const GET_MY_ORDER_IDS_SUCCESS = "APP/MY_ORDER/GET_MY_ORDER_IDS_SUCCESS";
export const GET_MY_ORDER_IDS_FAILURE = "APP/MY_ORDER/GET_MY_ORDER_IDS_FAILURE";
